import { isObjectDefined } from './object';

type StringNumber = number | string;

export const roundNumber = (number: number): number =>
  Math.round(number * 100) / 100;

export const convertPotentialStringToNumber = (
  number: StringNumber
): number | null => {
  if (!isObjectDefined(number)) {
    return null;
  }
  const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;
  return Number.isNaN(parsedNumber) ? null : parsedNumber;
};
